import { IUserRepository } from "../../adapters/driven/repositories/userRepository";

export const UserServiceImplFactory = ({
  userRepository,
}: {
  userRepository: IUserRepository;
}) => {
  const getUserBetaFeatures: IGetUserBetaFeatures = async () => {
    try {
      const response = await userRepository.getUserBetaFeatures();
      return {
        success: true,
        data: { data: response.data },
      };
    } catch (error) {
      return {
        success: false,
        error: { message: (error as unknown as Error).message },
      };
    }
  };

  const updateUserInfo: IUpdateUserInfo = async (payload) => {
    try {
      const response = await userRepository.updateUserInfo(payload);
      if ("detail" in response && typeof response.detail === "string") {
        return { success: false, error: { message: response.detail } };
      }
      return { success: true, data: response.data };
    } catch (error) {
      return {
        success: false,
        error: { message: (error as unknown as Error).message },
      };
    }
  };

  const signupUser: ISignupUser = async (payload) => {
    try {
      const response = await userRepository.signupUser(payload);

      // Check if the response is a success (has user_id and string message)
      if ("user_id" in response && typeof response.message === "string") {
        return {
          success: true,
          data: {
            message: response.message,
            user_id: response.user_id,
          },
        };
      }
      // Handle validation error response (has string[] message and data: null)
      else if ("message" in response && Array.isArray(response.message)) {
        return {
          success: false,
          error: {
            message: response.message,
            detail: undefined,
          },
        };
      }
      // Handle detail error response (has detail string)
      else if ("detail" in response && typeof response.detail === "string") {
        return {
          success: false,
          error: {
            message: undefined,
            detail: response.detail,
          },
        };
      }
      // Handle other message formats
      else if ("message" in response && typeof response.message === "string") {
        return {
          success: false,
          error: {
            message: response.message,
            detail: undefined,
          },
        };
      }
      // Fallback for unexpected response format
      else {
        return {
          success: false,
          error: {
            message: "Unexpected response format",
            detail: undefined,
          },
        };
      }
    } catch (error) {
      return {
        success: false,
        error: {
          message: (error as unknown as Error).message,
          detail: undefined,
        },
      };
    }
  };

  return { getUserBetaFeatures, updateUserInfo, signupUser };
};
